import React, {useEffect, useState} from "react";
// import Switch from "@mui/material/Switch";
import {AppName, DEF_APP_THEME, GenRouteUrls, Keys, ModuleFieldsData, ModuleRouteUrls, Modules, ReqUrls} from "../config/AppConfig";
import {Anchor, Flexbox, GridBox, Image, Label, MsgBox, Select, Switch} from "../../common/fusion-ui";
import {useTheme} from "../../common/ProjectThemeProvider";
import {
    clearRememberLastUrl,
    clearUserSessionData,
    focusFormIdElement,
    getRememberLastUrl,
    getUserSessionToken,
    printError,
    printLog,
    sendRequest
} from "../utils/AppUtils";
import {
    addClass,
    checkNullArr,
    checkNullJson,
    checkNullStr,
    getDefStr,
    getElement,
    getJsonValue,
    getJsonValueFromNestedKeys,
    isBoolTrue,
    isJsonValueTrue,
    setCookieInBrowser,
    setTabTitle
} from "../../common/fusion-ui/utils/ReactUtils";
import {CssVariant, Patterns} from "../../common/fusion-ui/config/FusionConfig";
import {useLocation, useNavigate} from "react-router-dom";
import {AuthPageLayout, InvalidBypassTokenLabel, ThemedButton, ThemedInput} from "../index";
import {useSubdomainData} from "../context/SubdomainProvider";
import {useLocalStoreData} from "../context/LocalStoreProvider";
import useScreenSize from "../../common/fusion-ui/hook/useScreenSize";
import {IsProd} from "../../common/CommonConfig";
import {useInternetStatus} from "../../common/fusion-ui/hook";
import {clearAdminSessionData} from "../../admin/utils/AdminUtils";

const LoginPage = React.memo(() => {
    const TAG = 'LoginPage';

    const navigate = useNavigate();
    const location = useLocation();
    const theme = useTheme();
    const {updateLocalStoreField} = useLocalStoreData();
    const {subdomainData, appTheme} = useSubdomainData();
    const {isScreenUpSm} = useScreenSize();
    const {isOnline} = useInternetStatus();

    const START_IN_PAGES = [Modules.Home, Modules.WebMeeting, Modules.DiscussionForum, Modules.Survey, Modules.Resources,];
    const FOCUS_DELAY = 2000;
    const INPUT_H = '46px';
    const PIN_MAX_LENGTH = 6;
    const DEF_IMG = `https://images.unsplash.com/photo-1637825891028-564f672aa42c`;

    const Fields = {
        username: 'username',
        password: 'password',
        rememberMe: 'rememberMe',
        startInPages: 'startInPages',
        startInSelectedPage: 'startInSelectedPage',
        loginWithPinEnabled: 'loginWithPinEnabled',
        loginPinValue: 'loginPinValue',

        usernameMsg: 'usernameMsg',
        passwordMsg: 'passwordMsg',
        loginPinValueMsg: 'loginPinValueMsg',

        submitAsLoading: 'submitAsLoading',
        submitDisable: 'submitDisable',
        panelMsg: 'panelMsg',
        panelMsgColor: 'panelMsgColor',
        lastUrl: 'lastUrl',
    };
    const [fieldsData, setFieldsData] = useState({});
    const [isLocalhost, setIsLocalhost] = useState(!IsProd);
    const [testData, setTestData] = useState({});

    useEffect(() => {
        setTabTitle(Modules.Login);
        if (!checkNullArr(getField(Fields.startInPages))) {
            const startPages = START_IN_PAGES.map(item => ({id: item, text: `${item} Page`}));
            // const startPages = START_IN_PAGES.map(item => item);
            updateField(Fields.startInPages, startPages)
            updateField(Fields.startInSelectedPage, START_IN_PAGES[0]);
        }

        // setCookieInBrowser({
        //     user: "john_doe",
        //     [Keys.theme]: appTheme,
        // });
        // setCookieInBrowser("lastUrl='/last-url'; remember=true");
        // setCookieInBrowser(["theme=Orchid", "loginFound=false"]);
        // log('useEffect.cookies:', getBrowserCookie([Keys.theme, Keys.reqPageImg, Keys.loginPageImg]));
        // log('useEffect.cookies.imgs:', getBrowserCookie([Keys.reqPageImg, Keys.loginPageImg]));
        // clearBrowserCookie(['user', 'lastUrl', 'remember', 'theme', 'loginFound', 'invalidKey'])
        // if (checkNullStr(getBrowserCookie(Keys.authUsername))) {
        //     updateField(Fields.username, getBrowserCookie(Keys.authUsername));
        //     updateField(isBoolTrue(getBrowserCookie(Keys.loginWithPinEnabled)) ? Fields.loginPinValue : Fields.password, getBrowserCookie(Keys.authPw));
        //     updateField(Fields.loginWithPinEnabled, isBoolTrue(getBrowserCookie(Keys.loginWithPinEnabled)));
        // }
    }, []);
    // useEffect(() => {
    // if (IsProd) {
    // const fun = 'sendTestRequest:';
    // try {
    //     sendRequest({
    //         reqUrl: ReqUrls.testRequest,
    //         type: 'get',
    //         onFetched: ((fetchedData) => {
    //             log(fun, 'fetchedData:', fetchedData);
    //             setTestData(fetchedData);
    //         }),
    //         onError: ((error) => {
    //             logErr(error);
    //         })
    //     });
    // } catch (error) {
    //     logErr(fun, error);
    // }
    // }
    // }, []);
    // useEffect(() => {
    //     // log('useEffect.location.pathname:', location.pathname);
    //     // if (!checkNullStr(getField(Fields.lastUrl))) updateField(Fields.lastUrl, location.pathname);
    // }, [location.pathname]);

    return (<AuthPageLayout className={'py-sm-4 '} px={0} py={1}
                            containerClassName={'container-sm'}
                            asContainer={false} asContainerFluid={false}>
        {/*{IsProd && <div>*/}
        {/*    testData: {jsonToStr(testData)}*/}
        {/*</div>}*/}
        <GridBox className={'m-0 p-0 auth-page bg-infox al-start-smx'}
                 sm={12} md={[6, 6]}
                 gap={0}
                 alignAt={'center'} justifyAt={'center'}
                 minHeight={isScreenUpSm ? '80vh' : '97vh'}
        >
            {/*left - imgPanelData image*/}
            {canShowImage() &&
                <div className={'m-0 p-0 pt-1 px-3 d-none-smx h-100 auth-img-wrapper'}>
                    <Image
                        wrapperClassName={`w-100 h-100 rounded-8 overflow-hidden select-none`}
                        className={`transition-sm`}
                        src={getJsonValue(subdomainData, Keys.subdomain_LoginImage, DEF_IMG)}
                        width={'100%'}
                        height={'550px'}
                        // style={{minHeight: '92vh'}}
                        objectFit={'cover'}
                        disableDrag={true}
                    />
                </div>}

            {/*right - login-panel*/}
            <div className={'m-0 p-0x row jc-center al-centerx al-start-smx xh-100 bg-dangerx auth-panel-right'}>
                <div
                    className={`m-0 p-0x px-sm-5x bg-infox col-sm-8 col-md-10 col-lg-8 auth-panel-wrapper ${canShowImage() ? 'has-image' : 'imageless'}`}>
                    {/*invalid-token-msg*/}
                    <InvalidBypassTokenLabel mtn={2}/>

                    {/*<div className={'m-0 p-0x px-sm-5x bg-infox col-sm-8 col-md-10 col-lg-8 auth-panel-wrapper'}>*/}
                    {/*top*/}
                    <div className={'m-0 p-0'}>
                        <Label className={'fw-bold fs-xl text-nowrap'} textAt={'start'}>
                            <span className={''} style={{color: theme.text90}}>
                                {` ${Modules.Login}`} to
                            </span>
                            <span className={''} style={{color: theme.primary}}>
                                {" "}{getJsonValue(subdomainData, Keys.subdomain_Name, AppName)}
                            </span>
                        </Label>
                    </div>

                    {/*form*/}
                    <div className={'m-0 p-0 mt-1 auth-form'}>
                        <form onSubmit={handleSubmit}>
                            {/*username*/}
                            <ThemedInput
                                mainWrapperClassName={`w-100 pb-2`}
                                className={`py-3`}
                                style={{height: INPUT_H}}
                                type={'email'}
                                id={Fields.username}
                                label={'Username'}
                                placeholder={'Enter your username'}
                                value={getField(Fields.username)}
                                required={true}
                                msg={getField(Fields.usernameMsg)}
                                onChange={(e, isValid) => {
                                    const value = e.target.value;
                                    updateField(Fields.username, value);
                                    if (checkNullStr(value)) {
                                        highlightIdField(Fields.username, false, Fields.usernameMsg, '');
                                    }
                                    panelLog('');
                                }}
                            />

                            {/*password*/}
                            {(!isFieldTrue(Fields.loginWithPinEnabled)) && <ThemedInput
                                mainWrapperClassName={`w-100 pb-2`}
                                className={`py-3`}
                                style={{height: INPUT_H}}
                                type={'password'}
                                id={Fields.password}
                                label={'Password'}
                                placeholder={'Enter your password'}
                                value={getField(Fields.password)}
                                required={true}
                                msg={getField(Fields.passwordMsg)}
                                onChange={(e, isValid) => {
                                    const value = e.target.value;
                                    updateField(Fields.password, value);
                                    if (checkNullStr(value)) {
                                        highlightIdField(Fields.password, false, Fields.passwordMsg, '');
                                    }
                                    panelLog('');
                                }}
                            />}

                            {/*loginPinValue*/}
                            {(isFieldTrue(Fields.loginWithPinEnabled)) && <ThemedInput
                                mainWrapperClassName={`w-100 pb-2`}
                                className={`py-3`}
                                style={{height: INPUT_H}}
                                type={'pin'}
                                id={Fields.loginPinValue}
                                label={'PIN'}
                                placeholder={'Enter your PIN'}
                                value={getField(Fields.loginPinValue)}
                                required={true}
                                showDefMsg={true}
                                validate={true}
                                pattern={Patterns.mobile}
                                msg={getField(Fields.loginPinValueMsg)}
                                onChange={(e) => {
                                    const value = e.target.value;
                                    if ((value + '').length <= PIN_MAX_LENGTH) {
                                        updateField(Fields.loginPinValue, value);
                                        // if (checkNullStr(value)) {
                                        highlightIdField(Fields.loginPinValue, false, Fields.loginPinValueMsg, '');
                                        //     let valid = Patterns.mobile.test(value);
                                        //     log('loginPinValue.onChange.value:', value, 'valid:', valid);
                                        //     highlightIdField(Fields.loginPinValue, !valid, Fields.loginPinValueMsg, valid ? '' : 'Invalid PIN');
                                        //     updateField(Fields.loginPinValue, value);
                                        // }
                                    }
                                    panelLog('');
                                }}
                            />}

                            {/*start-in page*/}
                            <Select
                                id={Fields.startInPages}
                                wrapperClassName={`w-100`}
                                labelClassName={`px-1 w-100 text-input-label`}
                                innerWrapperClassName={'w-100'}
                                className={`w-100 py-2 rounded-3`}
                                variant={'primary'}
                                justifyAt={'start'}
                                style={{height: INPUT_H}}
                                labelColor={theme.text30}
                                label={'Start In'}
                                textKey={'text'}
                                idKey={'id'}
                                required={true}
                                placeholder={'Select a page to start in'}
                                options={getField(Fields.startInPages, [])}
                                defOption={getField(Fields.startInSelectedPage)}
                                onChange={(e, text, value) => {
                                    log('startInPage.Select.onChange::text:', text, "value:", value);
                                    updateField(Fields.startInSelectedPage, value);
                                }}
                            />

                            {/*remember-switch & login-with-pin link*/}
                            <Flexbox className={'mt-2'} alignAt={'center'} justifyAt={'between'} wrap={'nowrap'}>
                                {/*remember-switch*/}
                                {/*<Flexbox className={''} alignAt={'center'} justifyAt={'start'}>*/}
                                {/*    <Switch checked={isFieldTrue(Fields.rememberMe)} onChange={handleSetRememberMe}/>*/}

                                {/*    <Label className={'m-0 p-0  text-nowrap select-none'} textAt={'start'} color={theme.text80}>*/}
                                {/*        &nbsp;&nbsp;{' Remember me'}*/}
                                {/*    </Label>*/}
                                {/*</Flexbox>*/}
                                {/*<div className={'d-flex w-auto'}>*/}
                                <Switch
                                    className={'w-auto'}
                                    labelColor={theme.text}
                                    checked={isFieldTrue(Fields.rememberMe)}
                                    defaultChecked={isFieldTrue(Fields.rememberMe)}
                                    onChange={handleSetRememberMe}>
                                    {'Remember me'}
                                </Switch>
                                {/*</div>*/}

                                {/*login-with-pin link*/}
                                <Label className={`m-0 p-0  text-nowrap footer-link select-none`}
                                       textAt={'start'}
                                       onClick={() => {
                                           updateField(Fields.loginWithPinEnabled, !isFieldTrue(Fields.loginWithPinEnabled))
                                       }}>
                                    {isFieldTrue(Fields.loginWithPinEnabled) ? "Login with Password" : 'Login with PIN'}
                                </Label>
                            </Flexbox>

                            {/*msg-box*/}
                            {(checkNullStr(getField(Fields.panelMsg)) || !isOnline) &&
                                <MsgBox color={!isOnline ? 'red' : getField(Fields.panelMsgColor, theme.text90)}>
                                    {!isOnline ? `You're offline!` : getField(Fields.panelMsg)}
                                </MsgBox>}


                            {/*submit*/}
                            <div className={'m-0 p-0 mt-2 mb-1 w-100'}>
                                <ThemedButton
                                    className={'w-100 px-2 py-2 rounded-3 fw-semi-bold'}
                                    text={isFieldTrue(Fields.submitAsLoading) ? 'Signing in...' : Modules.Login}
                                    height={INPUT_H}
                                    elasticActive={true}
                                    loadingWidth={'100%'}
                                    asLoading={isFieldTrue(Fields.submitAsLoading)}
                                    disabled={isFieldTrue(Fields.submitDisable) || !isOnline}
                                    onClick={handleSubmit}
                                />

                                {!IsProd && <ThemedButton
                                    className={'w-100 px-2 py-2 mt-4 rounded-3'}
                                    text={'Admin Login'}
                                    variant={theme.primaryAlt}
                                    variantLight={theme.primaryAltLight}
                                    href={'/admin/login'}
                                    asLink={false}
                                />}
                            </div>

                            {/*forgot-pw & request-access*/}
                            <Flexbox className={'w-100 mt-3 px-0'}
                                     justifyAt={'between'} alignAt={'center'}>
                                {/*forgot-pw*/}
                                <Anchor
                                    className={'text-nowrap fw-semi-boldx'}
                                    href={GenRouteUrls.forgotPw}>
                                    {Modules.ForgotPw}?
                                </Anchor>

                                {/*request-access*/}
                                <Label className={'text-nowrap m-0 p-0'} textAt={"start"}>
                                    <Anchor className={'text-nowrap fw-semi-boldx'}
                                            href={GenRouteUrls.requestAccess}>
                                        {Modules.RequestAccess}
                                    </Anchor>
                                </Label>
                            </Flexbox>
                        </form>
                    </div>
                </div>
            </div>
        </GridBox>
    </AuthPageLayout>);

    function handleSubmit(e) {
        const fun = 'handleSubmit:';
        // log(fun, 'lastUrl:', getField(Fields.lastUrl));
        panelLog('');
        clearUserSessionData();
        try {
            let verified = checkAllFieldsVerified();
            // verified = false;
            if (verified) {
                updateField(Fields.submitAsLoading, true);
                updateField(Fields.submitDisable, true);
                // const mf = ModuleFieldsData[Modules.UserProfile];

                const REQUEST_OPTIONS = {
                    username: getField(Fields.username),
                    password: isFieldTrue(Fields.loginWithPinEnabled) ? null : getField(Fields.password),
                    loginPin: getField(Fields.loginPinValue),
                    loginWithPinEnabled: isFieldTrue(Fields.loginWithPinEnabled),
                    token: getUserSessionToken(),
                    [Keys.browserUrl]: window.location.href,
                };

                sendRequest({
                    reqUrl: ReqUrls.login,
                    reqOptions: REQUEST_OPTIONS,
                    onFetched: (fetchedData) => {
                        log(fun, 'fetchedData:', fetchedData);

                        const message = getJsonValue(fetchedData, 'message');
                        const success = isJsonValueTrue(fetchedData, 'success');

                        if (success) {
                            const mf_company = ModuleFieldsData[Modules.Company];

                            const userData = getJsonValueFromNestedKeys(fetchedData, ['data', Keys.sessionData], {});
                            const token = getJsonValueFromNestedKeys(fetchedData, ['data', Keys.sessionToken], '');

                            const fetchedSubdomainData = getJsonValueFromNestedKeys(fetchedData, ['data', Keys.subdomainData], {});
                            const subdomainData = getJsonValue(fetchedSubdomainData, 'data', {});
                            const subdomainSuccess = isJsonValueTrue(fetchedSubdomainData, 'success');
                            const subdomainMessage = getJsonValue(fetchedSubdomainData, 'message');
                            const subdomainError = getJsonValue(fetchedSubdomainData, 'error');

                            // const loginPageImg = getJsonValue(subdomainData, mf_company.loginImg.column);
                            // const reqPageImg = getJsonValue(subdomainData, mf_company.reqacsImg.column);

                            const domainPrefs = getJsonValue(subdomainData, mf_company.domainPrefs.column);
                            const themeName = getJsonValue(domainPrefs, Keys.theme, DEF_APP_THEME);
                            // const themeName = ThemeName.ROYAL_BLUE;

                            // const domainUrl = getJsonValue(fetchedSubdomainData, 'domainUrl');
                            // log(fun, 'fetchedData.subdomainData:', subdomainData);
                            // log(fun, 'fetchedData.subdomainData.loginPageImg:', loginPageImg, 'reqPageImg:', reqPageImg);
                            // log(fun, 'fetchedData.subdomainData.domainPrefs:', domainPrefs, 'themeName:', themeName);
                            // log(fun, 'fetchedData.token:', token);
                            // log(fun, 'fetchedData.userData:', userData);
                            if (checkNullJson(subdomainData) && subdomainSuccess) {
                                if (checkNullStr(token) && checkNullJson(userData)) {
                                    panelLog(message);

                                    //Delete p/w fields
                                    // deleteJsonKeys(userData, [mf.password.column, mf.passwordV2.column]);

                                    //store user-data & token in local-storage
                                    updateLocalStoreField(Keys.sessionData, {...userData, [Keys.sessionToken]: token}, true);
                                    updateLocalStoreField(Keys.subdomainData, subdomainData, true);
                                    setCookieInBrowser({
                                        [Keys.theme]: themeName,
                                        // [Keys.reqPageImg]: reqPageImg,
                                        // [Keys.loginPageImg]: loginPageImg,
                                        // [Keys.authUsername]: getField(Fields.username),
                                        // [Keys.authPw]: isFieldTrue(Fields.loginWithPinEnabled) ? getField(Fields.loginPinValue) : getField(Fields.password),
                                        // [Keys.loginWithPinEnabled]: isFieldTrue(Fields.loginWithPinEnabled),
                                    });
                                    // setCookieInBrowser({...userData, token});
                                    // log(fun, 'getUserSessionData:', getUserSessionData());
                                    // log(fun, 'getSessionToken:', getUserSessionToken());
                                    // const lastRememberUrl = getRememberLastUrl(ModuleRouteUrls[Modules.Dashboard]);
                                    const lastRememberUrl = getRememberLastUrl();
                                    const intendedUrl = getDefStr(lastRememberUrl, ModuleRouteUrls[getField(Fields.startInSelectedPage)]);
                                    // const intendedUrl = getDefStr(ModuleRouteUrls[getField(Fields.startInSelectedPage)], ModuleRouteUrls[Modules.Dashboard]);
                                    log(fun, 'lastRememberUrl:', lastRememberUrl, 'intendedUrl:', intendedUrl, 'startInSelectedPage:', getField(Fields.startInSelectedPage));

                                    //Clear admin-session
                                    clearRememberLastUrl();
                                    clearAdminSessionData();
                                    window.location.href = intendedUrl;//for testing only
                                    // window.location.href = IsProd ? domainUrl : intendedUrl;//for production use only
                                } else {
                                    panelLogErr('Login failed, please try again');
                                    clearUserSessionData();

                                    if (!checkNullStr(token)) logErr('Token empty (from backend)');
                                    if (!checkNullStr(userData)) logErr('User-data empty (from backend)');

                                    log(fun, 'fetchedData.userData:', userData, 'token:', token);
                                }
                            } else {
                                // panelLogErr('Subdomain verification failed, please try again');
                                panelLogErr(subdomainMessage);
                                clearUserSessionData();
                                logErr(fun, 'fetchedData.subdomainData.subdomainError:', subdomainError);
                                logErr(fun, 'fetchedData.subdomainData:', subdomainData);
                            }
                        } else {
                            panelLogErr(message);
                            clearUserSessionData();
                        }
                        updateField(Fields.submitAsLoading, false);
                        updateField(Fields.submitDisable, false);
                    },
                    onError: (error) => {
                        performFailureTasks(error);
                    }
                });
            }
        } catch (error) {
            performFailureTasks(error);
        }

        function performFailureTasks(error) {
            panelLogErr('Login failed, please try again');
            updateField(Fields.submitAsLoading, false);
            updateField(Fields.submitDisable, false);
            if (error) logErr(fun, error);
            clearUserSessionData();
        }
    }

    function handleSetRememberMe() {
        updateField(Fields.rememberMe, !isFieldTrue(Fields.rememberMe));
    }

    function checkAllFieldsVerified() {
        let verified = false;
        if (!checkNullStr(getField(Fields.username))) {
            // panelLogErr("Username cannot be empty!");
            updateField(Fields.usernameMsg, 'Username cannot be empty');
            focusIdField(Fields.username);
        } else if (!checkNullStr(getField(Fields.password)) || !checkNullStr(getField(Fields.loginPinValue))) {
            if (isFieldTrue(Fields.loginWithPinEnabled) && !checkNullStr(getField(Fields.loginPinValue))) {
                focusIdField(Fields.loginPinValue);
                updateField(Fields.loginPinValueMsg, 'PIN cannot be empty');
                panelLogErr("PIN cannot be empty");
                // } else if (isFieldTrue(Fields.password)) {
            } else if (!checkNullStr(getField(Fields.password))) {
                focusIdField(Fields.password);
                updateField(Fields.passwordMsg, 'Password cannot be empty');
                panelLogErr("Password cannot be empty");
            } else {
                verified = true;
            }
        } else {
            updateField(Fields.usernameMsg, '');
            updateField(Fields.passwordMsg, '');

            if (isFieldTrue(Fields.loginWithPinEnabled)) {
                if ((getField(Fields.loginPinValue) + '').length < PIN_MAX_LENGTH) {
                    focusIdField(Fields.loginPinValue);
                    updateField(Fields.loginPinValueMsg, `PIN cannot be shorter than ${PIN_MAX_LENGTH} digits`);
                    panelLogErr(`PIN cannot be shorter than ${PIN_MAX_LENGTH} digits!`);
                } else {
                    verified = true;
                    panelLog("");
                }
            } else {
                verified = true;
                panelLog("");
            }
        }

        return verified;
    }

    function canShowImage() {
        // return checkNullStr(getJsonValue(subdomainData, Keys.subdomain_LoginImage)) && isJsonValueTrue(subdomainData, Keys.subdomain_ShowAuthPageImage)
        return true;
    }

    function updateField(field, value) {
        setFieldsData(prevState => ({...prevState, [field]: value}));
    }

    function getField(field, defValue) {
        return getJsonValue(fieldsData, field, defValue);
    }

    function isFieldTrue(field) {
        return isBoolTrue(getField(field), true, true);
    }

    function focusIdField(id, onlyFocus = true) {
        focusFormIdElement(id, onlyFocus, FOCUS_DELAY);
        highlightIdField(id, true);
    }

    function highlightIdField(id, highlight = true, msgField, msg, variant = CssVariant.danger) {
        if (checkNullStr(msgField)) updateField(msgField, msg);
        addClass(getElement(id, 'id'), variant, isBoolTrue(highlight));
    }

    function panelLog(text) {
        updateField(Fields.panelMsg, text);
        updateField(Fields.panelMsgColor, theme.text90);
        if (text) log(...[text]);
        ;
    }

    function panelLogErr(...text) {
        updateField(Fields.panelMsg, text);
        updateField(Fields.panelMsgColor, 'red');
        if (text) log(...[text]);
        ;
    }

    function log(...text) {
        printLog(TAG, ...text);
    }

    function logErr(...text) {
        printError(TAG, ...text);
    }
});

export default LoginPage;
